<script>
import Edit from '@wielink-application/shared/vue/layouts/partials/sidebar/edit.vue'
export default Edit;
</script>